import type { TimeRange } from '@mimir/common/util/timeRange';
import { readonly, ref } from 'vue';

const isEditing = ref(false);
export const isEditingTranscript = readonly(isEditing);
export function openTranscriptEditor() { isEditing.value = true; }
export function closeTranscriptEditor() { isEditing.value = false; }

const selectedRange = ref<TimeRange | null>(null);
export const selectedTranscriptRange = readonly(selectedRange);
export function setSelectedTranscriptRange(range: TimeRange | null) { selectedRange.value = range; }

const stateChange = ref(false);
export const transcriptStateChange = readonly(stateChange);
export function toggleTranscriptStateChange() { stateChange.value = !stateChange.value; }

const isTranslation = ref(false);
export const downloadTranslation = readonly(isTranslation);
export function useTranslation(value: boolean) { isTranslation.value = value; }
